module.exports = __webpack_public_path__ + "img/BAU Seniors_14.f162477b.jpg";